import { render, staticRenderFns } from "./catalog-btn.vue?vue&type=template&id=39e818d6&scoped=true&"
import script from "./catalog-btn.vue?vue&type=script&lang=js&"
export * from "./catalog-btn.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "39e818d6",
  null
  ,true
)

export default component.exports